const reviewStatusMap = {
  1: 'Not started',
  2: 'Engagement Leader - Pending',
  3: 'Engagement Leader - Completed',
  4: 'Manager - Pending',
  5: 'Manager - Completed',
  6: 'Reviewer - Pending',
  7: 'Reviewer - Completed',
  8: 'EL to Confirm',
  9: 'RQR Leader - Pending',
  10: 'Finished'
}

export default reviewStatusCode => reviewStatusMap[reviewStatusCode] || 'Review status not mapped yet'

export { reviewStatusMap }